var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    enableBackground: "new 0 0 22 22",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.028,5.131c-0.815,0.383-1.688,0.637-2.596,0.76c0.935-0.597,1.648-1.535,1.982-2.665 c-0.869,0.555-1.831,0.948-2.854,1.168c-0.827-0.942-2.006-1.526-3.292-1.526c-2.494,0-4.503,2.167-4.503,4.823 c0,0.38,0.031,0.748,0.104,1.098c-3.745-0.195-7.06-2.117-9.286-5.043c-0.389,0.723-0.617,1.55-0.617,2.438 c0,1.669,0.804,3.149,2.002,4.007c-0.725-0.017-1.435-0.24-2.036-0.594V9.65c0,2.343,1.562,4.29,3.609,4.737 c-0.366,0.108-0.766,0.158-1.182,0.158c-0.289,0-0.579-0.016-0.853-0.081c0.583,1.91,2.24,3.313,4.21,3.356 c-1.532,1.284-3.48,2.057-5.585,2.057c-0.37,0-0.725-0.018-1.079-0.066c1.996,1.379,4.36,2.163,6.911,2.163 c8.29,0,12.823-7.348,12.823-13.716c0-0.215-0.005-0.421-0.015-0.624c0.893-0.679,1.644-1.527,2.255-2.503V5.131z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b3168c455df48bd2a4a68cb62ee6911a.svg";
export { ForwardRef as ReactComponent };